// The one toast for every page. It lived in js/app.js (field PWA only), while
// 40+ admin sites called it behind `typeof showToast === 'function'` — so on
// admin.html every Save/Move/Delete confirmation and every error toast was
// skipped in silence (found 2026-10-17). Both pages load core.min.js, which
// publishes this as window.showToast; both pages carry #errorToast.
let hideTimer;   // the one toast's pending hide
// `action` ({ label, onClick }) adds one button — Undo after a money change.
// The toast then takes clicks and stays up long enough to reach it.
export function showToast(msg, type = 'info', action) {
  const toast = document.getElementById('errorToast');
  if (!toast) return;
  // Phone: the toast is bottom-anchored (styles.css, G3) and rides above any
  // card parked over the nav-bar — push/install offer, outbox pill. Stamp how
  // far up that card reaches; the CSS takes max(bar, card + 12px).
  const lift = Math.max(0, ...[...document.querySelectorAll('.install-card, .outbox-pill')]
    .map(el => el.offsetHeight ? window.innerHeight - el.getBoundingClientRect().top : 0));
  toast.style.setProperty('--toast-lift', `${Math.ceil(lift)}px`);
  toast.textContent = msg;
  if (action) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'toast-action';
    btn.textContent = action.label;
    btn.onclick = () => { hideToast(); action.onClick(); };
    toast.append(' ', btn);
  }
  toast.className = `toast toast-${type} visible${action ? ' toast--action' : ''}`;
  // One timer for the one toast: a new message restarts it, so an earlier
  // toast's timer ("Getting your location…", 3.2 s) cannot hide a later one early.
  clearTimeout(hideTimer);
  hideTimer = setTimeout(() => toast.classList.remove('visible'), action ? 8000 : type === 'info' ? 3200 : 4000);
}

// Clears an in-progress toast the moment the action it announced is over
// ("Generating PDF report..." over the Submitted screen) or the screen changes
// under it (admin switchTab). Nothing removed .visible early before this.
export function hideToast() {
  const toast = document.getElementById('errorToast');
  if (toast) toast.classList.remove('visible');
}
